import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useWeb3Modal } from '@web3modal/wagmi/react';
import { useAccount, useNetwork } from 'wagmi';
import walletStore from '../stores/walletStore';
import Button from './Button';
import WalletDropdown from './WalletDropdown';

export default function Header() {
  const store = walletStore();
  const { open } = useWeb3Modal();
  const { address, isConnected, isDisconnected } = useAccount();
  const { chain } = useNetwork();

  useEffect(() => {
    if (isConnected && address) {
      console.log('connected!');
      store.connect(address, chain?.id || 1);
    }

    if (isDisconnected) {
      store.disconnect();
    }
  }, [address, isConnected, isDisconnected]);

  return (
    <header className='header'>
      <Link to='/home'>
        <img
          width='62'
          src='/assets/ATVT_type_logo.svg'
          alt='아티비스트 로고'
        />
      </Link>
      <Link className='title' to='https://artivistglobal.com/' target='_blank'>
        official website
      </Link>
    </header>
  );
}
